import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import * as React from "react";
// import { useEffect } from "react";
import { useSelector } from "react-redux";

import HeaderAttachmentsReview from "./headerAttachmentsReview";
import LinesAttachmentsReview from "./linesAttachmentsReview";

const AttachmentsReview = ({ setIsNextButtonDisabled }) => {
    const [value, setValue] = React.useState("1");
    const reqLines = useSelector(
        (state) => state.createRequisition.iBuyRequisition.requisitionLines
    );
    const reqHeader = useSelector(
        (state) => state.createRequisition.iBuyRequisition.requisitionHeaderForm
    );

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        setIsNextButtonDisabled(false);
    }, []);

    return (
        <>
            <Typography
                textAlign="center"
                variant="h6"
                component="h6"
                fontWeight="bold"
            >
                Uploaded Attachments
            </Typography>

            <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="Items"
                            textColor="secondary"
                            indicatorColor="secondary"
                        >
                            <Tab label="Line Attachment" value="1" />
                            <Tab label="Header Attachment" value="2" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <LinesAttachmentsReview reqLineItems={reqLines} />
                    </TabPanel>
                    <TabPanel value="2">
                        <HeaderAttachmentsReview></HeaderAttachmentsReview>
                    </TabPanel>
                </TabContext>
            </Box>
        </>
    );
};

AttachmentsReview.propTypes = {
    setIsNextButtonDisabled: PropTypes.func,
};

export default AttachmentsReview;
